export const FTFMP_STATS_REPORT = 'FTFMP Stats Report';
export const SURVEY_ANALYTICS = 'Survey Analytics';
export const MBF_REPORT = 'MBF Report';
export const DRP_REPORT = 'DRP Report';
export const HMP_DETAIL_REPORT = 'HMP Detail Report';
export const HMP_SUMMARY_REPORT = 'HMP Summary Report';
export const TRIAL_COURT_REPORT = 'Trial Court Report';
export const REMAP_PARTICIPANT_REPORT = 'ReMAp Participant Report';
export const REMAP_CASE_REPORT = 'ReMAp Case Report';
export const REMAP_INFO_SESSION_REPORT = 'ReMAp Info Session Report';
export const MOPC_REPORTS = 'MOPC Reports';
